export enum FileMimeType {
    JPG = 'image/jpg',
    PNG = 'image/png',
    JPEG = 'image/jpeg',
    OCTET_STREAM = 'application/octet-stream',
    CSV = 'text/csv',
    XLS = 'application/vnd.ms-excel',
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    PDF = 'application/pdf',
    HTML = 'text/html'
}
